import { render, staticRenderFns } from "./EditPricelist.vue?vue&type=template&id=5353a3d6&"
import script from "./EditPricelist.vue?vue&type=script&lang=js&"
export * from "./EditPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports